import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {DatePipe} from '@angular/common';
import {AuthAccessProvider} from '../core/core.auth';
import {MessageProvider} from '../service/message.service';
import {UserService} from '../service/user.service';
import {EquipmentService} from '../service/equipment.service';
import {BusyProvider} from '../service/busy.service';
import {AppConstants} from '../core/app.constants';
import {Router} from '@angular/router';
import {UserContext, BaseComponent, Equipment, EquipmentsRequest, EquipmentUser, User, EquipmentUsersRequest, EquipmentType} from '../core/core.component';
import {SelectItem} from 'primeng/primeng';
import {Message} from 'primeng/components/common/api';

@Component({
  selector: 'app-equipment-users',
  templateUrl: './equipment-users.component.html',
  styleUrls: ['./equipment-users.component.css'],
})
export class EquipmentUsersComponent extends BaseComponent implements OnInit {

  @Output() newItemEvent = new EventEmitter<EquipmentUser>();

  openEquip(currentEquip: EquipmentUser){
    this.newItemEvent.emit(currentEquip);
  }

  private pattern = 'yyyy-MM-dd';

  locale: any = AppConstants.ITA_CALENDAR_CONF;
  userContext: UserContext;
  loading = false;
  showDeleteAlert = false;
  showFilter = false;

  users: SelectItem[] = [];
  usersAll: SelectItem[] = [];
  visibleUsersList: SelectItem[] = [];
  equipments: SelectItem[] = [];
  equipmentsAll: SelectItem[] = [];
  visibleEquipmentsList: SelectItem[] = [];
  equipmentTypes: SelectItem[] = [];
  equipmentTypesMap: Object;

  filterUsersAll: SelectItem[] = [];
  filterUsersActive: SelectItem[] = [];
  filterUsersSuggestions: SelectItem[] = [];

  filterSoloAttivi = true;
  filterSoloUtentiAttivi = true;
  filterUtenti: SelectItem[] = [];
  filterIdTipo: number = null;
  filterDataInizioAssegnazDa: Date = null;
  filterDataInizioAssegnazA: Date = null;
  filterDataFineAssegnazDa: Date = null;
  filterDataFineAssegnazA: Date = null;

  equipmentUsers: EquipmentUser[] = [];

  sortField = 'desUser';
  sortAsc = true;

  equipmentUserSelected: EquipmentUser = new EquipmentUser();
  validationMessage: string = null;

  equipmentUserId: number = null;
  equipmentUserIdUser: number = null;
  equipmentUserIdTipo: number = null;
  equipmentUserIdEquip: number = null;
  equipmentUserDataInizioAssegnaz: Date = new Date();
  equipmentUserDataFineAssegnaz: Date = null;

  msgs: Message[] = [];

  constructor(protected authAccess: AuthAccessProvider,
    protected router: Router,
    protected messageProvider: MessageProvider,
    private userService: UserService,
    private equipmentService: EquipmentService,
    private busyProvider: BusyProvider,
    private datePipe: DatePipe) {
    super(authAccess, router, messageProvider);
    this.messageProvider.clearAll();
  }

  ngOnInit() {
    this.userContext = this.authAccess.getUserContext();
    if (this.userContext == null) {
      this.authAccess.invalidate();
    } else {
      this.resetFilter();
      this.loadEquipments();
      this.loadUsers();
      this.loadEquipmentUsers();
      this.loadEquipmentTypes();
    }
  }

  resetFilter() {
    this.filterSoloUtentiAttivi = true;
    this.filterUtenti = [];
    this.filterIdTipo = null;
    this.filterDataInizioAssegnazDa = null;
    this.filterDataInizioAssegnazA = null;
    this.filterDataFineAssegnazDa = null;
    this.filterDataFineAssegnazA = null;
  }

  loadEquipmentTypes() {
    this.equipmentService.getEquipmentTypes(this.userContext.srmToken).subscribe(
      result => {
        const equipmentTypes: SelectItem[] = [{label: '', value: null}];
        const types = result.types;
        for (let i = 0; i < types.length; ++i) {
          const current: EquipmentType = types[i];
          equipmentTypes.push({label: current.desc, value: current.id});
        }
        this.equipmentTypes = equipmentTypes;
      },
      error => {
        this.handleError(error);
      });
  }

  loadEquipments() {
    this.equipments = [];
    this.equipmentsAll = [];
    this.equipmentTypesMap = new Object();
    const request = new EquipmentsRequest();
    request.soloAttivi = true;
    this.equipmentService.getEquipments(this.userContext.srmToken, request).subscribe(
      result => {
        this.equipments.push({label: '', value: null});
        const equipments = result.equipments;
        console.log(equipments);
        for (let i = 0; i < equipments.length; ++i) {
          const current: Equipment = equipments[i];
          var serialNumberString:String = "";
          if (current.serialNumber != undefined && current.serialNumber !=null && current.serialNumber != ""){
            serialNumberString = ' (' + current.serialNumber + ')';
          }
          if (current.idAssegnatario == undefined) {
            this.equipments.push({label: current.desc + serialNumberString, value: current.id});
          }
          this.equipmentsAll.push({label: current.desc + serialNumberString, value: current.id});
          var list = this.equipmentTypesMap[current.idTipo];
          if (!list) {
            list = [];
            this.equipmentTypesMap[current.idTipo] = list;
          }
          list.push(current.id);
        }
        if (this.equipmentUserSelected.idEquip == null) {
          this.filterEquipmentsUser();
        } else {
          this.visibleEquipmentsList = this.equipmentsAll;
        }
      },
      error => {
        this.handleError(error);
      });
  }

  loadUsers() {
    this.users = [];
    this.usersAll = [];
    this.filterUsersAll = [];
    this.filterUsersActive = [];
    this.userService.getUsers(this.userContext.srmToken, false, true).
      subscribe(
      result => {
        this.users.push({label: '', value: null});
        this.usersAll.push({label: '', value: null});
        for (let i = 0; i < result.users.length; ++i) {
          const current: User = result.users[i];
          if (current.active) {
            this.users.push({label: current.fullname, value: current.id});
          }
          const item: SelectItem = {label: current.fullname ? current.fullname : current.username, value: current.id};
          this.usersAll.push(item);
          this.filterUsersAll.push(item);
          if (current.active) {
            this.filterUsersActive.push(item);
          }
        }
        this.filterUsersAll.sort((a, b) => this.compareStrings(a.label, b.label));
        this.filterUsersActive.sort((a, b) => this.compareStrings(a.label, b.label));
        if (this.equipmentUserSelected.idEquip == null) {
          this.visibleUsersList = this.users;
        } else {
          this.visibleUsersList = this.usersAll;
        }
      },
      error => {
        this.handleError(error);
      });
  }

  loadEquipmentUsers() {
    this.equipmentUsers = [];
    this.loading = true;
    const request = new EquipmentUsersRequest();
    request.idUsers = this.filterUtenti.map(user => user.value);
    request.idTipo = this.filterIdTipo;
    request.dataInizioAssegnazDa = this.datePipe.transform(this.filterDataInizioAssegnazDa, this.pattern);
    request.dataInizioAssegnazA = this.datePipe.transform(this.filterDataInizioAssegnazA, this.pattern);
    request.dataFineAssegnazDa = this.datePipe.transform(this.filterDataFineAssegnazDa, this.pattern);
    request.dataFineAssegnazA = this.datePipe.transform(this.filterDataFineAssegnazA, this.pattern);
    request.soloAttivi = this.filterSoloAttivi;
    this.equipmentService.getEquipmentUsers(this.userContext.srmToken, request).subscribe(
      result => {
        this.equipmentUsers = result.results;
        this.equipmentUsers.sort(function(a, b) {
          return a.desUser > b.desUser ? 1 : -1;
        });
        this.loading = false;
        if (this.equipmentUserSelected != null && this.equipmentUserSelected.idEquip > 0) {
          this.selectEquipmentUser(this.equipmentUserSelected);
        }
        this.sort(this.sortField, this.sortAsc);
      },
      error => {
        this.handleError(error);
        this.loading = false;
      });
  }

  sort(field: string, asc?: boolean) {
    if (field === this.sortField && typeof asc === 'undefined') {
      this.equipmentUsers = this.equipmentUsers.reverse();
      this.sortAsc = !this.sortAsc;
    } else {
      this.sortField = field;
      this.equipmentUsers = this.equipmentUsers.sort((a1, a2) => {
        this.sortAsc = true;
        if (this.sortField === 'desUser') {
          return this.compareStrings(a1.desUser, a2.desUser);
        } else if (this.sortField === 'desEquip') {
          return this.compareStrings(a1.desEquip, a2.desEquip);
        } else if (this.sortField === 'tipo') {
          return this.compareStrings(a1.desTipo, a2.desTipo);
        } else if (this.sortField === 'sn') {
          return this.compareStrings(a1.serialNumber, a2.serialNumber);
        } else if (this.sortField === 'cespite') {
          return this.compareStrings(a1.codCespite, a2.codCespite);
        } else if (this.sortField === 'dtIni') {
          return this.compareDates(a1.dataInizioAssegnaz, a2.dataInizioAssegnaz);
        } else if (this.sortField === 'dtFin') {
          return this.compareDates(a1.dataFineAssegnaz, a2.dataFineAssegnaz);
        }
        return 0;
      });
    }
  }

  private compareStrings(s1: string, s2: string) {
    return (s1 ? s1.toLowerCase() : '') > (s2 ? s2.toLowerCase() : '') ? 1 : -1;
  }

  private compareDates(d1: Date, d2: Date) {
    if (!d1 && !d2) {
      return 0;
    } else if (!d1) {
      return -1;
    } else if (!d2) {
      return 1;
    } else {
      return +new Date(d1) - +new Date(d2);
    }
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  filterUser(event) {
    const source = this.filterSoloUtentiAttivi ? this.filterUsersActive : this.filterUsersAll;
    this.filterUsersSuggestions = AppConstants.filterSuggestions(source, event.query, item => [item.label])
      .filter(item => !this.filterUtenti.some(selected => selected.value === item.value));
  }

  onSoloUtentiAttiviChange() {
    // gli utenti non attivi già selezionati non sarebbero più visibili nell'elenco: li tolgo dal filtro
    if (this.filterSoloUtentiAttivi) {
      this.filterUtenti = this.filterUtenti.filter(selected =>
        this.filterUsersActive.some(item => item.value === selected.value));
    }
  }

  applyFilter() {
    this.loadEquipmentUsers();
    this.showFilter = false;
  }

  removeFilter() {
    this.resetFilter();
    this.loadEquipmentUsers();
    this.showFilter = false;
  }

  selectEquipmentUser(equipmentUser: EquipmentUser) {
    this.visibleEquipmentsList = this.equipmentsAll;
    this.visibleUsersList = this.usersAll;

    this.validationMessage = null;
    this.equipmentUserSelected = equipmentUser;
    this.equipmentUserId = equipmentUser.id;
    this.equipmentUserIdUser = equipmentUser.idUser;
    this.equipmentUserIdTipo = equipmentUser.idTipo;
    this.equipmentUserIdEquip = equipmentUser.idEquip;
    this.equipmentUserDataInizioAssegnaz = equipmentUser.dataInizioAssegnaz ? new Date(equipmentUser.dataInizioAssegnaz) : null;
    this.equipmentUserDataFineAssegnaz = equipmentUser.dataFineAssegnaz ? new Date(equipmentUser.dataFineAssegnaz) : null;
  }

  addNewEquipmentUser() {
    this.visibleEquipmentsList = this.equipments;
    this.visibleUsersList = this.users;
    
    this.validationMessage = null;
    this.messageProvider.clearAll();
    this.equipmentUserSelected = new EquipmentUser();
    this.equipmentUserId = null;
    this.equipmentUserIdUser = null;
    this.equipmentUserIdTipo = null;
    this.equipmentUserIdEquip = null;
    this.equipmentUserDataInizioAssegnaz = new Date();
    this.equipmentUserDataFineAssegnaz = null;
  }

  filterEquipmentsUser() {
    if (this.equipmentUserIdTipo === null) {
      this.visibleEquipmentsList = this.equipments;
    } else {
      this.visibleEquipmentsList = [];
      this.visibleEquipmentsList.push({label: '', value: null});
      var list: string[] = this.equipmentTypesMap[this.equipmentUserIdTipo];
      for (let i = 0; i < this.equipments.length; ++i) {
        const current = this.equipments[i];
        if (list.indexOf(current.value) > -1) {
          this.visibleEquipmentsList.push(current);
        }
      }
    }
  }

  storeEquipmentUser() {
    this.messageProvider.clearAll();
    this.validationMessage = null;

    if (this.equipmentUserIdUser == null) {
      this.validationMessage = 'Selezionare l\'utente';
      return;
    }
    if (this.equipmentUserIdEquip == null) {
      this.validationMessage = 'Selezionare l\'attrezzatura';
      return;
    }
    if (this.equipmentUserDataInizioAssegnaz == null) {
      this.validationMessage = 'Inserire la data di assegnazione';
      return;
    }

    const insert = this.equipmentUserSelected.idEquip == null || this.equipmentUserSelected.idEquip === 0;
    this.busyProvider.showBusyIndicator();
    this.equipmentService.upsertEquipmentUser(this.userContext.srmToken, insert, this.equipmentUserId, this.equipmentUserIdUser, this.equipmentUserIdEquip, this.equipmentUserDataInizioAssegnaz, this.equipmentUserDataFineAssegnaz).subscribe(
      result => {
        this.busyProvider.hideBusyIndicator();
        this.msgs = [];
        this.msgs.push({severity: 'success', summary: 'OK', detail: insert ? 'Inserimento eseguito correttamente' : 'Modifica eseguita correttamente'});
        if (insert) {
          this.addNewEquipmentUser();
        }
        this.loadEquipmentUsers();
      },
      error => {
        this.busyProvider.hideBusyIndicator();
        this.handleError(error);
      });
  }

  openDeleteAlert(current: EquipmentUser) {
    this.selectEquipmentUser(current);
    this.showDeleteAlert = true;
  }
  closeDeleteAlert() {
    this.showDeleteAlert = false;
  }

  deleteEquipmentUser() {
    this.messageProvider.clearAll();
    this.validationMessage = null;

    this.busyProvider.showBusyIndicator();
    this.equipmentService.deleteEquipmentUser(this.userContext.srmToken, this.equipmentUserId).subscribe(
      result => {
        this.busyProvider.hideBusyIndicator();
        this.msgs = [];
        this.msgs.push({severity: 'success', summary: 'OK', detail: 'Cancellazione eseguita correttamente'});
        this.addNewEquipmentUser();
        this.loadEquipmentUsers();
      },
      error => {
        this.busyProvider.hideBusyIndicator();
        this.handleError(error);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/equipment-users/equipment-users.component.ts